import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function GTranslateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"g_translate"}/>
}
